export default __webpack_public_path__ + "dim-d4f232.json";